import { Input, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApiUsers } from '../../../store/slices/api-user-slice';
import { fetchCustomers } from '../../../store/slices/customer-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const ApiUserForm = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [callCount, setCallCount] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: apiUsers } = useSelector((state) => state.apiUser);
    const { data: customers } = useSelector((state) => state.customer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchApiUsers());
        dispatch(fetchCustomers());
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && apiUsers.length) {
            const ID = searchParams.get('id');
            const selectedApiUser = apiUsers.filter((item) => item.api_user_id === ID);
            setUserName(selectedApiUser[0].user_name);
            setPassword(selectedApiUser[0].password);
            setCustomerId(selectedApiUser[0].customer_id);
            setCallCount(selectedApiUser[0].call_count);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, apiUsers]);

    const customerList = customers.map((customer) => (
        { value: customer.customer_id, label:  customer.customer_name}
    ));

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'user_name': userName,
            'password': password,
            'customer_id': customerId,
            'call_count': callCount,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.api_user_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/api_user/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/api-user-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setUserName('');
        setPassword('');
        setCallCount('');
        setCustomerId('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} API User</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>User Name:</label>
                    <Input 
                        onChange={(e) => setUserName(e.target.value)} 
                        value={userName}
                        size='large' 
                        placeholder='User Name' 
                    />
                </div>
                <div className='control'>
                    <label>Password:</label>
                    <Input.Password 
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        size='large' 
                        placeholder='Password' 
                    />
                </div>
                <div className='control'>
                    <label>Call Count:</label>
                    <Input 
                        onChange={(e) => setCallCount(e.target.value)}
                        value={callCount}
                        size='large'
                        placeholder='Call Count'
                    />
                </div>
                <div className='control'>
                    <label>Role:</label>
                    <Select
                        placeholder="Select Customer"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setCustomerId(value)}
                        options={customerList}
                        allowClear
                        { ...(customerId && { value: customerId }) }
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default ApiUserForm;
